import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import deleteCustomSIPHeader from 'API/CustomSIPHeaders/deleteCustomSIPHeader';

const useDeleteCustomSIPHeader = (resetToMainTable, onClose) => {
    const { currentScope } = useSelector((state) => state.login);

    return useMutation({
        mutationFn: async (headerId) => {
            try {
                const data = await deleteCustomSIPHeader(
                    headerId,
                    currentScope,
                ).then((res) => {
                    toast.success('Custom SIP Header deleted successfully');
                    if (onClose) {
                        onClose();
                    }
                    resetToMainTable();
                    return res;
                });
                return data;
            } catch (error) {
                console.error('Error deleting custom SIP header:', error);
                toast.error('Failed to delete custom SIP header');
                throw error;
            }
        },
    });
};

export default useDeleteCustomSIPHeader;
